












import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { EVENTS } from '../../bus/events.const';

@Component
export default class DefaultClose extends Vue {
  onClick() {
    this.$x.emit(EVENTS.CloseEmpathyX);
  }
}
